export enum ReportOrderItemSectionType {
  Basic = 0, // for static tabs
  ActivityStream,
  TableOfColumn,
  FreeTextField,
}
